<template>
  <modal :showing="show" :large="true">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">Structure</h6>
      <div class="closeFeature" @click="closeModal"></div>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-4">
        <d-row>
          <d-col md="5" cols="12">
            <d-form @submit.prevent="saveStructure">
              <div class="form-group">
                <label for="feInputName">{{ $t("structure.name") }} </label>
                <d-form-input
                  type="text"
                  id="feInputName"
                  v-model="structure.name"
                  :state="errors['name'] === undefined ? null : false"
                />
                <errors :errors="errors" field="name" />
              </div>
              <!-- Address -->
              <div class="form-group">
                <label for="feInputAddress">{{
                  $t("structure.address")
                }}</label>
                <d-form-input
                  type="text"
                  id="feInputAddress"
                  v-model="structure.address"
                  :state="errors['address'] === undefined ? null : false"
                />
                <errors :errors="errors" field="address" />
              </div>

              <d-form-row>
                <!-- Zip Code -->
                <d-col md="6" class="form-group">
                  <label for="inputZip">{{ $t("structure.zip.code") }}</label>
                  <d-form-input
                    type="text"
                    class="form-control"
                    id="inputZip"
                    v-model="structure.zipCode"
                    :state="errors['zipCode'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="zipCode" />
                </d-col>

                <!-- City -->
                <d-col md="6" class="form-group">
                  <label for="feInputCity">{{ $t("structure.city") }}</label>
                  <d-form-input
                    type="text"
                    id="feInputCity"
                    v-model="structure.city"
                    :state="errors['city'] === undefined ? null : false"
                  />
                  <errors :errors="errors" field="city" />
                </d-col>
              </d-form-row>
              <d-button type="submit" class="btn-accent">{{
                $t("structure.form.button.submit")
              }}</d-button>
            </d-form>
          </d-col>

          <d-col md="7" cols="12">
            <in-charge-selector
              ref="selectorInCharge"
              @updateInCharge="updateInCharge"
            />
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </modal>
</template>

<script>
import Modal from '../layout/Modal/Modal.vue';
import Errors from '../error/errors.vue';
import ErrorsHelper from '../../helper/ErrorsHelper';
import VueBootstrapTypehead from 'vue-bootstrap-typeahead';
import InChargeSelector from '../user/inCharge/InChargeSelector.vue';

export default {
  name: 'AddEditStructure',
  components: {
    InChargeSelector,
    VueBootstrapTypehead,
    Errors,
    Modal,
  },
  data() {
    return {
      structure: {},
      show: false,
      errors: {},
      requiredFields: ['name', 'address', 'zipCode', 'city'],
    };
  },
  computed: {
    filteredInChargeUsers() {
      return this.inChargeUsers.filter(user =>
        this.selectedInCharge.find(u => u.reference === user.reference) ===
          undefined);
    },
  },
  methods: {
    closeModal() {
      this.structure = {};
      this.selectedInCharge = [];
      this.show = false;
    },
    openModal(structure) {
      this.show = true;
      if (structure) {
        this.loadModel(structure);
      }
    },
    loadModel(structure) {
      this.structure = JSON.parse(JSON.stringify(structure));
      // TODO: Better way to handle the delay where show is false and selector is not yet appear
      setTimeout(() => {
        this.$refs.selectorInCharge.setInCharge(this.structure.inCharge);
      }, 50);
    },
    saveStructure() {
      this.errors = {};
      if (
        ErrorsHelper.checkErrors(
          this.requiredFields,
          this.structure,
          this.errors,
        )
      ) {
        if (this.structure.reference) {
          this.$services.structure.update(this.structure).then(() => {
            this.$emit('updateStructure');
            this.show = false;
            this.$miniToastr.success(this.$t('structure.edit.success'));
          });
        } else {
          this.$services.structure.create(this.structure).then(() => {
            this.$emit('updateStructure');
            this.show = false;
            this.$miniToastr.success(this.$t('structure.add.success'));
          });
        }
      }
    },
    updateInCharge(inCharge) {
      this.structure.inCharge = inCharge;
    },
  },
};
</script>
